import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useLocalizedRoutes } from '@homeproved/pro/feature-localized-routes';
import { useRegistrationFormData as useRegFormDataContext } from '@homeproved/shared/feature-forms';
import { useAnonymousCompany } from '@homeproved/shared/feature-company';

export const useRegistrationFormData = (
  companyId?: string,
  email?: string,
  firstName?: string,
  lastName?: string
) => {
  const { isSuccess, company } = useAnonymousCompany(companyId);
  const router = useRouter();
  const { getPath } = useLocalizedRoutes();
  const { data: registrationFormData, setData: setRegistrationFormData } = useRegFormDataContext();
  const [navigatedAway, setNavigatedAway] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      const newSectors = [];
      company.relations.sectors.forEach((sector) => {
        newSectors.push(sector.data.id);
      });

      setRegistrationFormData({
        ...company,
        userFirstName: firstName,
        userLastName: lastName,
        userEmail: email,
        sectorIds: newSectors,
        acceptPolicy: true,
      });
    }
  }, [isSuccess, company, setRegistrationFormData, email, firstName, lastName]);

  useEffect(() => {
    if (!companyId && registrationFormData == null && !navigatedAway) {
      if (firstName == null || lastName == null || email == null) {
        router.push(getPath('/registration/step1'), undefined, { shallow: true }).then();
      } else {
        router
          .push(
            getPath(
              `/registration/step1?email=${email}&firstname=${firstName}&lastname=${lastName}`
            ),
            undefined,
            { shallow: true }
          )
          .then();
      }
      setNavigatedAway(true);
    }
  }, [companyId, getPath, navigatedAway, registrationFormData, router, firstName, lastName, email]);

  const clear = useCallback(() => setRegistrationFormData(undefined), [setRegistrationFormData]);

  return { registrationFormData, clear };
};
